import { render } from "./InfoTab.vue?vue&type=template&id=5b66e3df&scoped=true&ts=true"
import script from "./InfoTab.vue?vue&type=script&lang=ts"
export * from "./InfoTab.vue?vue&type=script&lang=ts"

import "./InfoTab.vue?vue&type=style&index=0&id=5b66e3df&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b66e3df"]])

export default __exports__